import { Grid } from '@mui/material';

import { US_STATE_OPTIONS } from '../../../../constants';
import { disabledFutureDate } from '../../../../helpers';
import { FormAutocompleteField, FormDateField, FormTextField } from '../../components';

import type { ReferralFieldsProps } from './types';

export default function ReferralFields({
  formik,
  disabled,
  readOnly,
  saveField,
  backgroundColor,
  diagnosisToolOptions,
}: ReferralFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={1.5}>
        <FormDateField
          backgroundColor={backgroundColor}
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          readOnly={readOnly}
          label="Date"
          name="referral_date"
          onChange={saveField}
          placeholder="Select date"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.5}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Provider name"
          name="provider_name"
          onBlur={saveField}
          placeholder="Enter provider name"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Diagnosis tool"
          name="diagnosis_tool"
          onChange={saveField}
          options={diagnosisToolOptions}
          placeholder="Select diagnosis tool"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="City"
          name="city"
          onBlur={saveField}
          placeholder="Enter city"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="State"
          name="state"
          onChange={saveField}
          options={US_STATE_OPTIONS}
          placeholder="Select state"
          required
        />
      </Grid>
    </Grid>
  );
}
